import React, { Fragment } from 'react'
import Footer from '../../Components/Footer/Footer'
import Login from '../../Components/Login/Login'
function LoginPage() {
  return (
    <Fragment>
      <Login/>
      <Footer/>
    </Fragment>
  )
}

export default LoginPage